import VerifikasiRapor from "./partial/VerifikasiRapor";

export default function VerifikasiRaportPesertaDetailPage() {
  return (
    <div>
      <VerifikasiRapor />
    </div>
  );
}
